export default __webpack_public_path__ + "s2.png";